import { Paths } from "#/utils/Paths"
import { useTelemedicineAccess } from "@internal/telemedicine"
import React from "react"
import { Redirect, useLocation } from "react-router-dom"

// Program-agnostic entry for a generic "Book appointment" CTA: asks the backend which programs the
// member has and dispatches — none → home, single → that flow, multiple → the chooser. Program-
// specific entry points deep-link to the flow with `?program=` and skip this.
export function TelemedicineResolverPage(): JSX.Element | null {
  const { state } = useLocation()
  const { data: access, isLoading, isError } = useTelemedicineAccess()

  // A failed access read leaves us with no basis to dispatch — send the member home rather than
  // render a blank page (MEM-781).
  if (isError) {
    return <Redirect to={Paths.HOME} />
  }

  if (isLoading || !access) {
    return null
  }

  const { entry } = access

  // No programs, or the member's one program is one they aren't qualified for → home. Unqualified
  // members no longer get a booking link (MEM-817), so routing them into the flow (where they'd only
  // hit the not-eligible page) is dead UX — send them home instead (MEM-781).
  if (entry.status === "none" || entry.status === "single_unqualified") {
    return <Redirect to={Paths.HOME} />
  }

  if (entry.status === "single_qualified") {
    return <Redirect to={{ pathname: Paths.TELEMEDICINE_BOOKING, search: `?program=${entry.program}`, state }} />
  }

  // multiple
  return <Redirect to={{ pathname: Paths.PROVIDER_FINDER, state }} />
}
